import { createReducer, on } from '@ngrx/store';
import * as OpportunityLinksActions from './opportunity-links.actions';
import { OpportunityLinksState } from './opportunity-links.state';

export const initialState: OpportunityLinksState = {
  links: [],
  loading: false,
  error: null,
};

export const opportunityLinksReducer = createReducer(
  initialState,
  on(OpportunityLinksActions.loadOpportunityLinks, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(OpportunityLinksActions.loadOpportunityLinksSuccess, (state, { links }) => ({
    ...state,
    links,
    loading: false,
  })),
  on(OpportunityLinksActions.loadOpportunityLinksFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(OpportunityLinksActions.createOpportunityLinkSuccess, (state, { link }) => ({
    ...state,
    links: [...state.links, link],
  })),
  on(OpportunityLinksActions.updateOpportunityLinkSuccess, (state, { link }) => ({
    ...state,
    links: state.links.map((l) => (l.id === link.id ? link : l)),
  })),
  on(OpportunityLinksActions.deleteOpportunityLinkSuccess, (state, { link }) => ({
    ...state,
    links: state.links.filter((l) => l.id !== link.id),
  }))
);
